import styled from "styled-components";

export const ContainerCenter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding-bottom: 20px;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const Title = styled.h1`
  font-size: 22px;
  font-weight: 900;
  color: ${(p) => p.theme.tokens.colors.ink};
  text-align: center;
  max-width: 500px;
  margin: 0;
`;

export const SubTitle = styled.p`
  font-size: 15px;
  color: ${(p) => p.theme.tokens.colors.muted};
  text-align: center;
  max-width: 500px;
  margin: 0 0 10px;
`;
